import { api } from '@/utils/api'
import { MemberExtended } from '@/types'
import { useInfiniteLoading } from './useInfiniteLoading'

type Args = {
  organizationId?: string
  excludeTeamId?: string
}

const fetchOrganizationMembers = async (
  { pageParam }: { pageParam: number },
  { organizationId, excludeTeamId }: Args
) => {
  const resp = await api.get(`/organizations/${organizationId}/members`, {
    params: { excludeTeamId, page: pageParam },
  })
  return {
    data: resp.data.data ?? [],
    totalCount: resp.data.totalCount ?? 0,
  }
}

export const useOrganizationMembers = ({
  organizationId,
  excludeTeamId,
}: Args) => {
  return useInfiniteLoading<MemberExtended>({
    enabled: !!organizationId,
    queryKey: ['organization-members', organizationId, excludeTeamId],
    queryFn: (p) => fetchOrganizationMembers(p, { organizationId, excludeTeamId }),
  })
}
